// Board #105: a room id captured from the "View your conversation" email link
// (https://knexoapp.com/room/:roomId), held until the app is authenticated and
// the navigator is ready to open the conversation. Kept in a module (not React
// state) so the value survives the auth-driven navigator swap and is read once.
let pendingRoomId: string | null = null;

export function setPendingRoom(roomId: string | null): void {
  pendingRoomId = roomId;
}

/** Return the pending room id and clear it (consume-once). */
export function takePendingRoom(): string | null {
  const value = pendingRoomId;
  pendingRoomId = null;
  return value;
}
